
import React, { useEffect } from "react";
import { Container, Typography, Box, Grid } from "@mui/material";

const  Seccion_Terminos = () => {

    useEffect(() => {
        document.title = "Términos y Condiciones | Diego Polo Tecnología";

        const meta = document.createElement("meta");
        meta.name = "description";
        meta.content =
            "Lee los Términos y Condiciones de Diego Polo Tecnología. Conoce las reglas de uso de nuestro sitio web, derechos, responsabilidades y contacto.";
        document.head.appendChild(meta);

        // JSON-LD para SEO
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Términos y Condiciones | Diego Polo Tecnología",
            description:
                "Reglas y condiciones para el uso del sitio web y servicios de Diego Polo Tecnología.",
            publisher: {
                "@type": "Organization",
                name: "Diego Polo Tecnología",
                url: "https://diegopolotecnologia.com",
            },
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(meta);
            document.head.removeChild(script);
        };
    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Container maxWidth="md" sx={{ py: 8, maxWidth:1400, px:3 }} >
                <Typography variant="h3" gutterBottom>
                    Términos y Condiciones
                </Typography>

                <Typography variant="body1" paragraph>
                    Bienvenido a Diego Polo Tecnología. Al acceder y utilizar este sitio web,
                    aceptas cumplir con los siguientes términos y condiciones. Te recomendamos
                    leerlos atentamente.
                </Typography>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        1. Uso del sitio web
                    </Typography>
                    <Typography variant="body1" paragraph>
                        El contenido de este sitio es únicamente con fines informativos. Te
                        comprometes a no utilizarlo con fines ilegales, dañinos o que puedan
                        afectar el funcionamiento del sitio o de terceros.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        2. Propiedad intelectual
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Todo el contenido publicado en este sitio, incluyendo textos, imágenes,
                        logotipos y diseños, pertenece a Diego Polo Tecnología, salvo que se
                        indique lo contrario. Está prohibida su reproducción sin autorización
                        previa.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        3. Limitación de responsabilidad
                    </Typography>
                    <Typography variant="body1" paragraph>
                        No nos hacemos responsables por daños directos o indirectos derivados
                        del uso de este sitio web o de la información que contiene. El uso del
                        sitio es bajo tu propio riesgo.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        4. Enlaces externos
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Este sitio puede contener enlaces a sitios externos. Diego Polo
                        Tecnología no se hace responsable por el contenido ni las políticas de
                        dichos sitios.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        5. Modificaciones
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nos reservamos el derecho de modificar estos términos y condiciones en
                        cualquier momento. Te recomendamos revisarlos periódicamente.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        6. Ley aplicable
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Estos términos se rigen por la legislación vigente en Colombia. Cualquier
                        disputa se someterá a la jurisdicción de los tribunales competentes en
                        Colombia.
                    </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        7. Contacto
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Si tienes dudas sobre estos términos, puedes contactarnos al correo:{" "}
                        <strong>contacto@diegopolotecnologia.com</strong>.
                    </Typography>
                </Box>
            </Container>
        </Grid>
    )

}
export default Seccion_Terminos